.sentence {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.tagInput {
  min-width: 6rem;
  padding: var(--tuna-spacing-1);
}
